import Vue from "vue";
import router from "@/router";
import config from "@/configs/config";

var _this = Vue.prototype;

var xs = {};

var objectToQueryString = function (object) {
    var queryStringArray = [];
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            queryStringArray.push(encodeURIComponent(key) + "=" + encodeURIComponent(object[key]));
        }
    }
    return queryStringArray.join("&");
}

xs.request = function (object) {
    var url = object.url || "";
    var data = object.data || {};
    var header = object.header || {};
    var method = object.method || "GET";
    var success = object.success || null;
    var fail = object.fail || null;
    var complete = object.complete || null;

    var response = {};

    var xhr = new XMLHttpRequest();

    xhr.onerror = function () {
        response.errMsg = "request:fail";
        if (typeof fail === "function") {
            fail(response);
        }
        if (typeof complete === "function") {
            complete(response);
        }
    };

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            response.errMsg = "request:ok";
            response.statusCode = xhr.status;
            try {
                response.data = JSON.parse(xhr.response);
            } catch (e) {
                response.data = xhr.response;
            }
            if (typeof success === "function") {
                success(response);
            }
            if (typeof complete === "function") {
                complete(response);
            }
        }
    };

    if (method.toUpperCase() === "GET") {
        if (data) {
            xhr.open(method, url + "?" + objectToQueryString(data));
        } else {
            xhr.open(method, url);
        }
        for (var key in header) {
            if (header.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, header[key]);
            }
        }
        xhr.send();
    } else if (method.toUpperCase() === "POST") {
        xhr.open(method, url);
        for (var key in header) {
            if (header.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, header[key]);
            }
        }
        xhr.send(objectToQueryString(data));
    }
};

xs.uploadFile = function (object) {
    var url = object.url || "";
    var filePath = object.filePath || "";
    var name = object.name || "";
    var header = object.header || {};
    var success = object.success || null;
    var fail = object.fail || null;
    var complete = object.complete || null;

    var response = {};

    var xhr = new XMLHttpRequest();

    xhr.onerror = function () {
        response.errMsg = "uploadFile:fail";
        if (typeof fail === "function") {
            fail(response);
        }
        if (typeof complete === "function") {
            complete(response);
        }
    };

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            response.errMsg = "uploadFile:ok";
            response.statusCode = xhr.status;
            try {
                response.data = JSON.parse(xhr.response);
            } catch (e) {
                response.data = xhr.response;
            }
            if (typeof success === "function") {
                success(response);
            }
            if (typeof complete === "function") {
                complete(response);
            }
        }
    };

    xhr.open("POST", url);
    for (var key in header) {
        if (header.hasOwnProperty(key)) {
            xhr.setRequestHeader(key, header[key]);
        }
    }
    var formData = new FormData();
    formData.append(name, filePath);
    xhr.send(formData);
}

var request = function (url, method, data) {
    return new Promise(function (resolve, reject) {
        _this.$toast.loading({
            message: "数据加载中...",
            forbidClick: true
        });
        xs.request({
            url: config.requestBaseUrl + url,
            data: data,
            header: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Token": localStorage.getItem("token")
            },
            method: method,
            success: function (res) {
                _this.$toast.clear();
                console.log("[xs.request:success]\n" + "url:" + config.requestBaseUrl + url + "\n" + "data:" + JSON.stringify(data) + "\n" + "method:" + method + "\n" + "res:" + JSON.stringify(res) + "\n");
                if (res.statusCode >= 200 && res.statusCode < 300 || res.statusCode === 304) {
                    if (res.data.responseCode == 0) {
                        resolve(res.data);
                    } else {
                        _this.$toast("" + res.data.responseMessage);
                        reject(res);
                    }
                } else {
                    _this.$toast("获取数据失败！");
                    reject(res);
                }
            },
            fail: function (res) {
                _this.$toast.clear();
                console.log("[xs.request:fail]\n" + "url:" + config.requestBaseUrl + url + "\n" + "data:" + JSON.stringify(data) + "\n" + "method:" + method + "\n" + "res:" + JSON.stringify(res) + "\n");
                _this.$toast("获取数据失败！");
                reject(res);
            }
        });
    });
};

var uploadFile = function (url, name, filePath) {
    return new Promise(function (resolve, reject) {
        _this.$toast.loading({
            message: "数据加载中...",
            forbidClick: true
        });
        xs.uploadFile({
            url: config.uploadFileBaseUrl + url,
            filePath: filePath,
            name: name,
            header: {
                "Token": localStorage.getItem("token")
            },
            success: function (res) {
                _this.$toast.clear();
                console.log("[wx.request:success]\n" + "url:" + config.uploadFileBaseUrl + url + "\n" + "filePath:" + filePath + "\n" + "name:" + name + "\n" + "res:" + JSON.stringify(res) + "\n");
                if (res.statusCode >= 200 && res.statusCode < 300 || res.statusCode === 304) {
                    if (res.data.responseCode == 0) {
                        resolve(res.data);
                    } else {
                        _this.$toast("" + res.data.responseMessage);
                        reject(res);
                    }
                } else {
                    _this.$toast("文件上传失败！");
                    reject(res);
                }
            },
            fail: function (res) {
                _this.$toast.clear();
                console.log("[xs.request:fail]\n" + "url:" + config.uploadFileBaseUrl + url + "\n" + "filePath:" + filePath + "\n" + "name:" + name + "\n" + "res:" + JSON.stringify(res) + "\n");
                _this.$toast("文件上传失败！");
                reject(res);
            }
        });
    });
};

var api = {
    getTempCategoryList: function (data) {
        var url = "api/temp/getCategoryList";
        var method = "GET";
        return request(url, method, data);
    },
    getTempList: function (data) {
        var url = "api/temp/getTempList";
        var method = "GET";
        return request(url, method, data);
    }
};

export default api;
